import { render, staticRenderFns } from "./contractMagytrack.vue?vue&type=template&id=395f31f0&"
import script from "./contractMagytrack.vue?vue&type=script&lang=js&"
export * from "./contractMagytrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports